import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import get from 'lodash/get';

import messages from './messages';
import Form from '../../../../components/Form';
import HubsEntityCollection from '../../../../components/HubsEntityCollection';
import Label from '../../../../components/Label';
import '../styles.css';

// check the string contains integer
// eslint-disable-next-line
const ErrorLabel = <Label role="tooltip" basic color="red" pointing><FormattedMessage {...messages.invalidError} /></Label>;

export const testScoresLabels = {
  25: '25th Percentile',
  50: 'Average',
  75: '75th Percentile',
};

export const EntityComponent = ({ entity, handleChange, order }) => (
  <React.Fragment>
    <div styleName="field">
      <label styleName="menu-field-label" htmlFor={`${entity.eid}-25`}>{testScoresLabels['25']}</label>
      <Form.Input
        type="number"
        min="0"
        id={`${entity.eid}-25`}
        error={get(entity, 'showError.25')}
        name="25"
        fluid
        placeholder={testScoresLabels['25']}
        value={entity['25']}
        order={order}
        onChange={(e, value) => handleChange(e, value, null, order)}
      />
      {get(entity, 'showError.25') && ErrorLabel}
      <label styleName="menu-field-label" htmlFor={`${entity.eid}-50`}>{testScoresLabels['50']}</label>
      <Form.Input
        type="number"
        min="0"
        id={`${entity.eid}-50`}
        error={get(entity, 'showError.50')}
        name="50"
        fluid
        placeholder={testScoresLabels['50']}
        value={entity['50']}
        order={order}
        onChange={(e, value) => handleChange(e, value, null, order)}
      />
      {get(entity, 'showError.50') && ErrorLabel}
      <label styleName="menu-field-label" htmlFor={`${entity.eid}-75`}>{testScoresLabels['75']}</label>
      <Form.Input
        type="number"
        min="0"
        id={`${entity.eid}-75`}
        error={get(entity, 'showError.75')}
        name="75"
        fluid
        placeholder={testScoresLabels['75']}
        value={entity['75']}
        order={order}
        onChange={(e, value) => handleChange(e, value, null, order)}
      />
      {get(entity, 'showError.75') && ErrorLabel}
    </div>
  </React.Fragment>
);

EntityComponent.propTypes = {
  entity: PropTypes.object,
  handleChange: PropTypes.func,
  order: PropTypes.number,
};

const TestScores = ({ onChange, ...props }) => (
  <HubsEntityCollection
    {...props}
    disableRemove
    nonUnique
    _allowedKeyValues={['0', '1', '2', '3', '4', '5', '6', '7', '25']}
    _key="he_testtype_id"
  >
    <EntityComponent handleChange={onChange} />
  </HubsEntityCollection>
);

TestScores.propTypes = {
  initialValue: PropTypes.array,
  onChange: PropTypes.func,
  mapper: PropTypes.object,
};

export default TestScores;
